import { useEffect, useState } from "react";
import InputFactory from "../../../../../components/InputFactory";
import NetSummary from "./NetSummary";
import { getOtherValues, parseFormattedNumber } from "./utils";
import formatMoney from "../../../../../formatMoney";
import { dialog } from "../../../../../nq-component";
import ToastSuccess from "../../../../../components/ToastSuccess";
import FormField from "../FormField";
import { calculateNetAndVat } from "./utils";

function toDateOnly(value) {
  if (value == null || value === "") return "";
  if (typeof value === "string") return value.slice(0, 10);
  const d = value instanceof Date ? value : new Date(value);
  return isNaN(d.getTime()) ? "" : d.toISOString().slice(0, 10);
}

function FormDialog({
  onSubmit,
  object,
  schema,
  schemas,
  minDate,
  maxDate,
  disabled,
  clientId,
  ...props
}) {
  const emptySupplier = (s) => !s || (typeof s === "object" && s.id == null);

  const [formData, setFormData] = useState(() => ({
    id: object?.id || crypto.randomUUID(),
    date: toDateOnly(object?.date) || "",
    supplier: emptySupplier(object?.supplier) ? "" : object?.supplier,
    gross: parseFormattedNumber(object?.gross) || "",
    net: object?.net || "",
    vat: object?.vat || "",
    vatExempt: object?.vatExempt || "",
    zeroRated: object?.zeroRated || "",
    image: object?.image || "",
    status: object?.status || "pending",
    bank: object?.bank || "",
    category: object?.category || "",
  }));
  const [showToast, setshowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [tinNo, setTinNo] = useState(object?.supplier?.tinNo || "N/A");
  const [uploading, setUploading] = useState(0);

  const onChange = (value, field) => {
    setFormData((prev) => ({ ...prev, [field]: value }));

    if (field === "supplier") {
      setFormData((prev) => ({ ...prev, [field]: value }));

      setTinNo(value?.tinNo || "N/A");
    }

    if (field === "gross") {
      setFormData((prev) => ({ ...prev, [field]: value }));
    }
  };

  useEffect(() => {
    const otherValues = calculateNetAndVat(
      formData,
      formData?.supplier?.isVatable,
    );

    setFormData((prev) => ({
      ...prev,
      net: otherValues.net,
      vat: otherValues.vat,
    }));
  }, [
    formData.gross,
    formData.vatExempt,
    formData.zeroRated,
    formData.supplier,
    formData.supplier?.isVatable,
  ]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const otherValues = getOtherValues(formData);

    const updatedObject = {
      ...formData,
      date: toDateOnly(formData.date) || formData.date,
      gross: formatMoney(formData.gross),
      net: otherValues.net,
      vat: otherValues.vat,
    };

    const originalForCompare = {
      ...object,
      date: toDateOnly(object?.date) || object?.date,
    };

    if (formData?.supplier?.isVatable === false) {
      delete updatedObject.vatExempt;
    }

    onSubmit(updatedObject, originalForCompare);
    // let updatedReceipts;
    // if (object && object?.gross) {
    //   await updateItem(updatedObject.id, updatedObject);
    //   updatedReceipts = receipts.map((receipt) =>
    //     receipt.id === updatedObject.id ? updatedObject : receipt
    //   );
    // } else {
    //   await addItem(updatedObject);
    //   updatedReceipts = [updatedObject, ...receipts];
    // }
  };

  return (
    <>
      <div className="m-0 card bg-white p-3">
        <div className="d-flex flex-column">
          <div style={{ borderBottom: "1px solid gray" }}>
            <p className="mb-1" style={{ fontSize: "0.9rem" }}>
              Transaction Details
            </p>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="d-flex flex-column gap-2 my-2">
              <FormField className={"h-100"} label="Image">
                <InputFactory
                  type="Image"
                  field="image"
                  object={formData}
                  value={formData?.image || ""}
                  defaultValue={formData?.image || ""}
                  className="border border-1 border-dark-subtle bg-white"
                  height={"10rem"}
                  onChange={onChange}
                  disabled={disabled}
                  setUploading={setUploading}
                />
              </FormField>

              <FormField label="Date" required>
                <InputFactory
                  type="Date"
                  field="date"
                  required
                  min={minDate}
                  max={maxDate}
                  placeholder="Enter Date"
                  defaultValue={formData?.date || ""}
                  className="border border-1 border-dark-subtle bg-white"
                  onChange={onChange}
                  disabled={disabled}
                />
              </FormField>

              <div className="d-flex gap-2">
                <FormField label="Supplier" required>
                  <InputFactory
                    type="Pointer"
                    target="suppliers"
                    schema={schema}
                    schemas={schemas}
                    field="supplier"
                    includes={["all"]}
                    keys={["isVatable", "tinNo"]}
                    where={{
                      $and: [{ client: { id: clientId } }, { isActive: true }],
                    }}
                    required
                    placeholder="Select Supplier"
                    object={formData}
                    className="border border-1 border-dark-subtle bg-white"
                    onChange={onChange}
                    disabled={disabled}
                  />
                </FormField>

                <FormField label="TIN">
                  <InputFactory
                    type="String"
                    target="suppliers"
                    //   field="supplier"
                    disabled
                    placeholder="000-000-000"
                    value={tinNo}
                    className="border border-1 border-dark-subtle bg-light"
                    //   onChange={onChange}
                  />
                </FormField>
              </div>

              <div className="d-flex gap-2">
                <FormField label="Bank" required className="flex-grow-1">
                  <InputFactory
                    type="Pointer"
                    target="banks"
                    object={formData}
                    schema={schema}
                    schemas={schemas}
                    field="bank"
                    includes={["all"]}
                    where={{
                      client: { id: clientId },
                    }}
                    required
                    placeholder="Select Bank"
                    disabled={disabled}
                    className="border border-1 border-dark-subtle bg-white"
                    onChange={onChange}
                    {...props}
                  />
                </FormField>

                <FormField label="Category" required className="flex-grow-1">
                  <InputFactory
                    type="Enum"
                    field="category"
                    options={["Capital Goods", "Services", "Others"]}
                    placeholder="Select category"
                    defaultValue={formData?.category || ""}
                    className="border border-1 border-dark-subtle bg-white"
                    required
                    disabled={disabled}
                    onChange={onChange}
                    {...props}
                  />
                </FormField>
              </div>

              <div className="d-flex gap-2">
                <FormField label={`Total Amount`} required>
                  <InputFactory
                    type="Currency"
                    field="gross"
                    required
                    placeholder="0.00"
                    // value={tinNo}
                    defaultValue={formData?.gross || ""}
                    className="border border-1 border-dark-subtle bg-white w-100"
                    onChange={onChange}
                    disabled={disabled}
                  />
                </FormField>

                {formData?.supplier?.isVatable ? (
                  <FormField label="Gross (VAT Exempt)">
                    <InputFactory
                      type="Currency"
                      field="vatExempt"
                      placeholder="0.00"
                      defaultValue={formData?.vatExempt}
                      className="border border-1 border-dark-subtle bg-white w-100"
                      onChange={onChange}
                      disabled={disabled}
                    />
                  </FormField>
                ) : (
                  ""
                )}
              </div>

              {formData?.supplier?.isVatable ? (
                <FormField label="Zero Rated">
                  <InputFactory
                    type="Currency"
                    field="zeroRated"
                    placeholder="0.00"
                    defaultValue={formData?.zeroRated}
                    className="border border-1 border-dark-subtle bg-white w-100"
                    onChange={onChange}
                    disabled={disabled}
                    {...props}
                  />
                </FormField>
              ) : (
                ""
              )}
              <NetSummary net={formData?.net} vat={formData?.vat} />
            </div>

            <div className="d-flex gap-2">
              <button
                type="button"
                className="flex-fill btn btn-light fw-bold"
                onClick={() => dialog.close()}
                style={{ backgroundColor: "#D1D1D1" }}
              >
                Cancel
              </button>
              {!disabled && (
                <button
                  type="submit"
                  className="flex-fill btn btn-primary fw-bold"
                  disabled={disabled || uploading > 0}
                >
                  {uploading > 0
                    ? "Uploading..."
                    : formData.gross
                      ? "Update"
                      : "Save"}
                </button>
              )}
            </div>
          </form>
        </div>
        <div
          className="toast-container position-fixed"
          style={{ transform: "translate(-50%,-50%)", top: "10%", left: "50%" }}
        >
          <ToastSuccess show={showToast} message={toastMessage} />
        </div>
      </div>
    </>
  );
}

export default FormDialog;
